import clsx from "clsx";
import { FunctionComponent } from "react";

import * as styles from "@ui/components/article/ShareButtons/components/ShareButtonsSharePopover/ShareButtonsSharePopover.css";
import * as shareButtonsStyles from "@ui/components/article/ShareButtons/ShareButtons.css";
import ThreadsIcon from "@ui/components/icon/social/ThreadsIcon";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  title: string;
  onPopoverClose: () => void;
}

/**
 * Threads share button component for the share popover
 */
const ShareButtonsThreadsPopover: FunctionComponent<Props> = ({
  url,
  title,
  onPopoverClose,
}) => {
  const analytics = useAnalytics();

  const handleThreadsShare = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "threads" },
    });

    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const threadsUrl = `https://threads.net/intent/post?text=${encodedTitle}&url=${encodedUrl}&via=Verge`;
    window.open(
      threadsUrl,
      "share_threads",
      "width=658, height=354, scrollbars=no",
    );
    onPopoverClose();
  };

  return (
    <button
      onClick={handleThreadsShare}
      className={styles.shareOption}
      aria-label="Share on Threads"
    >
      <span
        className={clsx(
          shareButtonsStyles.button.standard,
          styles.shareIconContainer,
        )}
      >
        <ThreadsIcon className={styles.shareIcon} />
      </span>
      <span className={styles.shareLabel}>Threads</span>
    </button>
  );
};

export default ShareButtonsThreadsPopover;
